


























import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import SimpleCard from '../cards/SimpleCard.vue';

export default defineComponent({
	components: {
		SimpleCard,
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		icon: {
			type: Object as PropType<FontAwesomeIconProps>,
			required: true,
		},
		editLabel: {
			type: String,
			default: 'edit-button',
		},
		isEditable: Boolean,
	},
});
